import React from "react";
import { type FontFamilyValues } from "@excalidraw/element/types";
import { FONT_FAMILY, getFontFamilyString } from "@excalidraw/common";
import { PropertiesPopover } from "../PropertiesPopover";
import { ScrollableList } from "../ScrollableList";
import DropdownMenuItem from "../dropdownMenu/DropdownMenuItem";
import { useExcalidrawContainer } from "../App";
import { t } from "../../i18n";

interface LofiFontMenuProps {
  selectedFontFamily: FontFamilyValues | null;
  onSelect: (value: number) => void;
  onClose: () => void;
}

const LOFI_FONTS = [
  { value: FONT_FAMILY.Nunito, text: "Regular" },
  { value: FONT_FAMILY["Nunito Bold"], text: "Bold" },
  { value: FONT_FAMILY["Nunito Italic"], text: "Italic" },
  { value: FONT_FAMILY["Comic Shanns"], text: "Comic" },
  { value: FONT_FAMILY.Excalifont, text: "handwriting" },
  { value: FONT_FAMILY["Lilita One"], text: "Phat" },
];

export const LofiFontMenu = React.memo(
  ({ selectedFontFamily, onSelect, onClose }: LofiFontMenuProps) => {
    const { container } = useExcalidrawContainer();
    
    return (
      <PropertiesPopover 
        container={container}
        onClose={onClose}
        style={{ width: "10rem" }}
        side="left"
        align="start"
      >
        <div className="lofi-font-menu">
          <ScrollableList 
            className="dropdown-menu fonts lofi-font-list"
            placeholder={t("fontList.empty")}
          >
            {LOFI_FONTS.map((font, index) => (
              <DropdownMenuItem
                key={font.value}
                value={font.value}
                order={index}
                textStyle={{
                  fontFamily: getFontFamilyString({ fontFamily: font.value }),
                }}
                selected={font.value === selectedFontFamily}
                tabIndex={font.value === selectedFontFamily ? 0 : -1}
                onClick={(e) => {
                  onSelect(Number(e.currentTarget.value));
                }}
              >
                {font.text}
              </DropdownMenuItem>
            ))}
          </ScrollableList>
        </div>
      </PropertiesPopover>
    );
  }
);

LofiFontMenu.displayName = "LofiFontMenu"; 